import React from 'react'
import irelandApi from '../irelandApi';
import {toast} from 'react-toastify'
import store, {history} from "../store"
import {actions} from 'react-redux-form'
import setAuthorizationToken from '../utils/tokenUtils'
import {getMyProfile} from "./user"
import ToastMessage from '../components/common/toast-message'

export const getQuestions = () => (dispatch) => {
  dispatch({type: 'SECURITY_QUESTIONS_PENDING', payload: []});

  return irelandApi.get('/api/security_questions')
                   .then(function (response) {
                     dispatch({type: 'SECURITY_QUESTIONS_FULFILLED', payLoad: response.data.data});
                   })
                   .catch(function (error) {
                     dispatch({type: 'SECURITY_QUESTIONS_REJECTED', payLoad: error});
                   });
};

export const getInvitationInfo = (token) => (dispatch) => {
  dispatch({type: 'INVITATION_TOKEN_PENDING', payload: []});

  return irelandApi.get('/api/users/invitation/accept', {params: {invitation_token: token}})
                   .then(function (response) {
                     const data = {
                       ...response.data.user
                     };
                     if (data.email) {
                       data.comms_email = 'true';
                     } else if (data.mobile) {
                       data.comms_mobile = 'true';
                     }
                     dispatch(actions.merge('deep.about_you.user', data));
                     dispatch({type: 'INVITATION_TOKEN_FULFILLED', payLoad: response.data});
                   })
                   .catch(function (error) {
                     toast.error(<ToastMessage iconStyle="warning" message="The given invitation token is invalid, please check the invitation email"/>);
                     history.push('/login');
                     dispatch({type: 'INVITATION_TOKEN_REJECTED', payLoad: error});
                   });
};


export const saveAboutYouStaff = (payload, registration, invitationToken) => {
  const data = {
    user: {...payload},
  };
  delete data.user.outlet;

  data.user.invitation_token = invitationToken;

  return irelandApi.patch('/api/users/invitation', data)
                   .then((response) => {
                     const token = response.headers.authorization.split(' ')[1];
                     setAuthorizationToken(token);
                     store.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
                     store.dispatch({type: 'FINISH_REGISTRATION'});
                     if(registration.pending && registration.internal){
                       history.push('/your-store')
                     } else {
                       history.push('/about-ignite');
                     }
                   })
                   .catch((error) => {
                     store.dispatch(actions.resetValidity('deep.about_you.user'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

export const saveAboutYouOwner = (payload, registration) => {
  const data = {
    user: {...payload},
    registration_token: registration.registration_token
  };
  delete data.user.outlet;

  return irelandApi.post('/api/users/about_you', data)
                   .then((response) => {
                     store.dispatch({
                       type:    'SET_REGISTRATION_TOKEN',
                       payLoad: {registration_token: response.data.registration_token}
                     });
                     if(registration.pending && registration.internal){
                       history.push('/your-store')
                     } else {
                       store.dispatch({type: 'UPDATE_YOU_FULFILLED', payLoad: response.data});
                       history.push('/registration/your-store')
                     }
                   })
                   .catch((error) => {
                     store.dispatch(actions.resetValidity('deep.about_you.user'));
                     store.dispatch({
                       type:    'SET_REGISTRATION_TOKEN',
                       payLoad: {registration_token: error.response.data.registration_token}
                     });
                     const data = {
                       ...error.response.data.errors.user[0]
                     };
                     return Promise.reject(data);
                   })
};




// WEBPACK FOOTER //
// ./src/actions/about-you.js